<template>
    <app-title :title="project.name" />
    <!-- eslint-disable max-len -->
    <section class="max-w-5xl mx-auto px-5 mt-20">
        <img class="max-w-sm mx-auto mb-10"
             :src="assets['images/moc.svg']"
             alt="">
        <div class="text-slate-500 text-center prose-lg mx-auto"
             v-html="project.text"></div>
        <div class="mt-10 text-center space-y-3 sm:space-y-0 space-x-3">
            <a class="btn-sky font-semibold inline-flex items-center" href="#">
                <span class="mr-2">
                    <shopping-bag-icon class="h-6 w-6" />
                </span>
                Where and how to buy the game?
            </a>
            <a class="btn-sky font-semibold inline-flex items-center" href="#">
                <svg class="h-6 w-6 mr-2"
                     xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor"
                     viewBox="0 0 16 16">
                    <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z" />
                </svg>
                Discord
            </a>
        </div>
    </section>
    <section class="container mx-auto px-5 border-t border-slate-300/10 my-20"></section>
    <section class="max-w-7xl mx-auto px-5">
        <div class="flex flex-col md:flex-row bg-slate-800 border border-slate-300/10 rounded-3xl mb-20">
            <div class="flex flex-1 flex-col p-10 md:p-20">
                <h2 class="text-2xl bg-linear-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text text-transparent mb-10 xl:text-3xl">
                    Take part of exciting missions
                </h2>
                <div class="prose prose-lg">
                    In addition to the main mission, you will encounter many side missions.
                </div>
            </div>
            <div class="w-full rounded-b-3xl md:rounded-bl-none md:max-w-96 md:rounded-r-3xl">
                <img class="w-full rounded-b-3xl md:rounded-bl-none md:rounded-r-3xl md:h-full md:object-cover"
                     :src="assets['images/fps-line-1.png']"
                     alt="">
            </div>
        </div>
    </section>
    <section class="max-w-7xl mx-auto px-5">
        <div class="flex flex-col md:flex-row bg-slate-800 border border-slate-300/10 rounded-3xl mb-20">
            <div class="w-full rounded-t-3xl md:rounded-t-none md:max-w-96 md:rounded-l-3xl">
                <img class="w-full rounded-t-3xl md:rounded-t-none md:rounded-l-3xl md:h-full md:object-cover"
                     :src="assets['images/fps-line-2.png']"
                     alt="">
            </div>
            <div class="flex flex-1 flex-col p-10 md:p-20">
                <h2 class="text-2xl bg-linear-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text text-transparent mb-10 xl:text-3xl">
                    Explore alien worlds
                </h2>
                <div class="prose prose-lg">
                    Unknown worlds are waiting for you to discover and get to know their wonders.
                </div>
            </div>
        </div>
    </section>
    <section class="container mx-auto px-5 border-t border-slate-300/10 my-20"></section>
    <section class="max-w-xl mx-auto px-5">
        <div class="rounded-3xl p-10 my-20 bg-slate-800/60 ring-1 ring-slate-300/10">
            <h2 class="text-2xl text-center bg-linear-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text text-transparent mb-10 xl:text-3xl">
                Subscribe to our Newsletter
            </h2>
            <form method="post"
                  novalidate
                  @submit.prevent="form.post(
                      route('fps_subscribe', $page.props.app.locale), {
                          preserveScroll: true,
                          onSuccess: () => { form.reset(); }
                      }
                  )">
                <div v-if="form.recentlySuccessful" class="text-green-500 text-center mb-10">
                    {{ trans['messages.success.subscribe'] }}
                </div>
                <div class="mb-4">
                    <input v-model="form.email"
                           class="form-input block w-full"
                           :class="{'form-invalid': form.errors.email}"
                           type="email"
                           name="email"
                           :placeholder="trans['validation.attributes.email']"
                           required>
                    <div v-if="form.errors.email" class="mt-2 text-sm text-red-500">
                        {{ form.errors.email }}
                    </div>
                </div>
                <div class="mb-4">
                    <input v-model="form.name"
                           class="form-input block w-full"
                           :class="{'form-invalid': form.errors.name}"
                           type="text"
                           name="name"
                           :placeholder="trans['validation.attributes.name']"
                           required>
                    <div v-if="form.errors.name" class="mt-2 text-sm text-red-500">
                        {{ form.errors.name }}
                    </div>
                </div>
                <div class="mb-10">
                    <label class="flex items-center">
                        <input v-model="form.gdpn"
                               class="form-checkbox mr-2"
                               :class="{'form-invalid': form.errors.gdpn}"
                               type="checkbox"
                               name="gdpn">
                        {{ trans['messages.accept_gdpn'] }}
                        <a class="link ml-1"
                           href="#"
                           @click.prevent="openDataProcessing">
                            {{ trans['validation.attributes.gdpn'] }}
                        </a>.
                    </label>
                    <div v-if="form.errors.gdpn" class="mt-2 text-sm text-red-500">
                        {{ form.errors.gdpn }}
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="btn-sky font-semibold px-12"
                            type="submit"
                            :disabled="form.processing">
                        {{ trans['messages.subscribe'] }}
                    </button>
                </div>
            </form>
        </div>
    </section>
    <div class="max-w-7xl mx-auto px-5 mb-20">
        <div class="flex flex-col items-center sm:flex-row">
            <img :src="assets['images/ue.svg']" alt="">
            <img class="h-16 sm:ml-auto"
                 :src="assets['images/pegi.svg']"
                 alt="">
            <img class="h-16 sm:ml-5"
                 :src="assets['images/esrb.png']"
                 alt="">
        </div>
    </div>
    <!-- eslint-enable max-len -->
</template>

<script setup>
import {
    ShoppingBagIcon
} from '@heroicons/vue/24/outline';

import { defineProps, defineOptions } from 'vue';
import { useForm } from '@inertiajs/vue3';
import Layout from '../../base/Layout';

defineProps({
    app: {
        type: Object,
        required: true
    },

    assets: {
        type: Object,
        required: true
    },

    project: {
        type: Object,
        required: true
    },

    posts: {
        type: Array,
        required: true
    },

    textBlocks: {
        type: Object,
        required: true
    },

    trans: {
        type: Object,
        required: true
    }
});

defineOptions({
    layout: Layout
});

const openDataProcessing = () => {
    document.dispatchEvent(new Event('open-data-processing'));
};

const form = useForm({
    name: '',
    email: '',
    gdpn: false
});
</script>
